let lua = require('./stdlib')
// let luax = require('./cocos2d')
let helpers = require('./helper')

let _G = global
global._G = _G
_G._VERSION = 'Lua 5.1'

function copy(dist, src) {
    for (let key in src) {
        if (dist[key]) {
            // console.warn('lua.js polyfill: Duplicate key ' + key)
        }
        dist[key] = src[key]
    }
}

copy(_G, lua)
// copy(_G, luax)
copy(_G, helpers)

module.exports = _G